import { FormControl, Validators } from '@angular/forms';
import { ProposalDeliverable } from '@teem/models/proposal-deliverable';

export class ProposalDeliverableForm {
	uuid = new FormControl();
	title = new FormControl('', [Validators.required]);
	quantity = new FormControl(0, [Validators.required, Validators.min(1)]);
	rate = new FormControl(0, [Validators.required, Validators.min(0)]);

	constructor(deliverable: ProposalDeliverable) {
		if (deliverable.uuid)
			this.uuid.setValue(deliverable.uuid);

		this.title.setValue(deliverable.title);
		this.quantity.setValue(deliverable.quantity);
		this.rate.setValue(deliverable.rate);
	}

	get cost() {
		return this.quantity.value * this.rate.value;
	}
}
